import { LiveEventRace } from 'services/api/database/EventService'

export const formatPriceFromCents = (price: number, symbol: string) =>
  price === 0
    ? `0 ${symbol}`
    : `${(price / 100).toFixed(2).replace('.', ',')} ${symbol}`

interface CartTotalParams {
  /** The price of the item in cents. */
  price: number
  /** The fees for the item in cents. */
  fees?: number
  /** The options for the item in cents. */
  options?: number
  /** The price of the competition pass in cents. */
  competitionPassPrice?: number
  /** The reductions for the item in cents. */
  reductions?: number
}

/**
 * Calculates the total cost of a cart.
 *
 * @param price - The base price of the cart.
 * @param fees - The additional fees for the cart (default: 0).
 * @param options - The additional options for the cart (default: 0).
 * @param competitionPassPrice - The price of the competition pass for the cart (default: 0).
 * @param reductions - The reductions applied to the cart (default: 0).
 * @returns The total cost of the cart in cents.
 */
export const cartTotal = ({
  price,
  fees = 0,
  options = 0,
  competitionPassPrice = 0,
  reductions = 0
}: CartTotalParams) =>
  Math.max(0, price - reductions) + fees + options + competitionPassPrice

export const getMinQuantity = (race: LiveEventRace) =>
  race.priceType === 'PER_PERSON' &&
  race.paymentCollectionType === 'SINGLE' &&
  race.minTeamSize &&
  race.maxTeamSize &&
  race.minTeamSize === race.maxTeamSize
    ? race.minTeamSize * race.raceSegments.length
    : undefined
